// components/EventDetails.js
import React from 'react';
import './EventDetails.css';
import heroImage from "../assets/locationinfo.jpeg";


const EventDetails = () => {
  return (
    <section className="event-details" id="events">
      <div className="container">
        <div className="event-header">
          <h2>Location and Event Information</h2>
        
        </div>
        
        <div className="event-content">
          <div className="event-image">
            <div className="image-container">
              <img 
                src={heroImage }
                alt="Restaurant venue" 
              />
              <div className="image-overlay"></div>
            
            </div>
          </div>
          
          <div className="event-info">
            <div className="details-card">
              <div className="detail-item">
                <div className="detail-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path fillRule="evenodd" d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="detail-content">
                  <h3>Venue</h3>
                  <p>Burs Restaurant, 6151 Steilacoom Blvd SW, Lakewood, WA 98499 </p>
                </div>
              </div>
              
              <div className="detail-item">
                <div className="detail-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="detail-content">
                  <h3>Schedule</h3>
                  <p>Wednesdays from 11:30 AM to 1:00 PM</p>
                </div>
              </div>
              
              <div className="detail-item highlight">
                <div className="detail-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9.375 3a1.875 1.875 0 000 3.75h1.875v4.5H3.375A1.875 1.875 0 011.5 9.375v-.75c0-1.036.84-1.875 1.875-1.875h3.193A3.375 3.375 0 0112 2.753a3.375 3.375 0 015.432 3.997h3.943c1.035 0 1.875.84 1.875 1.875v.75c0 1.036-.84 1.875-1.875 1.875H12.75v-4.5h1.875a1.875 1.875 0 10-1.875-1.875V6.75h-1.5V4.875C11.25 3.839 10.41 3 9.375 3zM11.25 12.75H3v6.75a2.25 2.25 0 002.25 2.25h6v-9zM12.75 12.75v9h6.75a2.25 2.25 0 002.25-2.25v-6.75h-9z" />
                  </svg>
                </div>
                <div className="detail-content">
                  <h3>Special Offer</h3>
                  <p>First and second consecutive visit free then $50 a month (visits must be consecutive)</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventDetails;
